/** UPLOAD */
const STATUS_INITIAL = 0, STATUS_UPLOADING = 1, STATUS_INGESTING = 2, STATUS_FETCHING = 3, STATUS_SUCCESS = 4, STATUS_FAILED = 5;

export const isInitial   = state => state.currentStatus === STATUS_INITIAL;
export const isUploading = state => state.currentStatus === STATUS_UPLOADING;
export const isIngesting = state => state.currentStatus === STATUS_INGESTING;
export const isFetching  = state => state.currentStatus === STATUS_FETCHING;
export const isSuccess   = state => state.currentStatus === STATUS_SUCCESS;
export const isFailed    = state => state.currentStatus === STATUS_FAILED;

